<template>
  <div>
    <div class="bg-light-gray rounded-bottom p-2">
      <div
        class="bg-white rounded p-1 p-md-3"
        :class="isMobile && 'p-1 p-md-2'"
      >
        <p class="font-16 mb-3">
          <i class="fas fa-redo mr-2 text-orange"></i>
          Generación de reporte
        </p>

        <validation-observer ref="generateForm" v-slot="{}" tag="form">
          <div class="row mt-3">
            <location-filters v-model="locationFilters" :data="model" />
            <div class="col-12 px-0">
              <div class="row">
                <div class="col-12 mb-4">
                  <filter-row
                    v-for="filter in filterOptions"
                    :key="filter.id"
                    :item="filter"
                    :conditionals="coditionalOptions"
                    :show-addons="false"
                    generation-mode
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="alert alert-warning d-inline-block" role="alert">
              <div class="alert-icon">
                <i class="fas mr-2 fa-bell-exclamation" />
              </div>
              <div class="alert-content">
                <span>
                  Los datos generados a través de esta herramienta son para uso
                  interno de los funcionarios del Departamento de Educación de
                  Puerto Rico. La divulgación de los mismos debe tener
                  autorización de la SAEE.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMobile" class="row mt-4 mb-3">
          <div class="col-12 d-md-flex justify-content-md-end">
            <div class="row">
              <div class="col-12 col-md-7">
                <action-button
                  @click="generate"
                  i="fas fa-chart-bar"
                  variant="success"
                  id="btn-search"
                  text="Generar informe"
                  class="mb-2 w-100"
                />
              </div>
              <div class="col-12 col-md-5">
                <action-button
                  @click="$emit('close')"
                  i="fas fa-times-circle"
                  variant="outline-danger"
                  id="btn-search"
                  text="Cerrar"
                  class="w-100"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row mt-4 mb-3">
          <div class="col-12 d-flex justify-content-end">
            <action-button
              @click="$emit('close')"
              i="fas fa-times-circle"
              variant="outline-danger"
              id="btn-search"
              text="Cerrar"
              class="mr-3"
            />
            <action-button
              @click="generate"
              i="fas fa-chart-bar"
              variant="success"
              id="btn-search"
              text="Generar informe"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpecialService from '@/services/api/special.api'
import ActionButton from 'ActionButton'
import FilterRow from './FilterRow.vue'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
import { ValidationObserver } from 'vee-validate'
import LocationFilters from './LocationFilters'
import rbDataType from '@/utils/constants/rbDataType.js'

export default {
  name: 'GenerateInform',
  components: {
    ValidationObserver,
    ActionButton,
    LocationFilters,
    FilterRow,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    conditionals: [],
    sources: [],
    model: {
      locationFilters: [],
    },
    locationFilters: {
      centerDisabled: true,
      municipalityDisabled: true,
      schoolDisabled: true,
      locationFilters: [],
      academicYear: null,
      center: null,
      municipality: null,
      school: null,
    },
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    filterOptions() {
      return (
        this.filters.map((e) => {
          let result = null

          if (e.dataType == rbDataType.Select) {
            if (e.isMultiSelect) {
              const ids = e.value.split(',').map((e) => parseInt(e))
              result = e.source
                ?.filter((m) => ids.includes(m.id))
                .map((e) => ({ ...e, selected: true }))
            } else {
              result = e.source?.find((m) => m.id == e.value)
            }
          }

          if (e.dataType == rbDataType.Date) {
            if (e.isMultiSelect) {
              result = [new Date(e.value), new Date(e.value2)]
            } else {
              result = e.value
            }
          }

          return {
            ...e,
            model: {
              conditional: this.coditionalOptions.find(
                (x) => x.id == e.conditional.id
              ),
              value:
                e.dataType == rbDataType.Select || e.dataType == rbDataType.Date
                  ? result
                  : e.value,
            },
          }
        }) || []
      )
    },
    coditionalOptions() {
      return this.conditionals || []
    },
  },
  mounted() {
    this.getConditionals()
  },
  methods: {
    async getConditionals() {
      const { data } = await SpecialService.getConditionals()
      this.conditionals = data
    },
    async generate() {
      const isValid = await this.$refs.generateForm.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }
      const subTopics = this.value.selectedColumns.map((i) => i.subTopicId)
      const uniqueSubTopics = [...new Set(subTopics)]

      const payload = {
        id: this.value.id,
        topicId: this.value.topic.id,
        selectedColumns: this.value.selectedColumns.map((e) => ({
          id: e.id,
          subTopicId: e.subTopicId,
          tableId: e.tableId,
          order: e.sortOrder,
        })),
        selectedFilters: this.filterOptions.map((e) => ({
          subTopicId: e.subTopicId,
          id: e.id,
          columnName: e.columnName,
          tableId: e.tableId,
          conditional: e.model.conditional,
          dataType: e.dataType,
          ...this.getValue(e),
        })),
        selectedFilterByLocation: this.model.locationFilters,
        SubTopics: uniqueSubTopics,
      }
      const { data } = await SpecialService.generate(payload)

      if (data) {
        this.ShowToast(
          'Proceso Exitoso',
          'Informe especial generado exitosamente',
          'success'
        )
        this.$emit('saved')
      }
    },
    clear() {
      this.filterSelected = null
      this.filters = []
      this.filtersSaved = []
      this.conditionals = []
    },
    getValue(e) {
      const { dataType, isMultiSelect } = e
      if (dataType === rbDataType.Date && isMultiSelect) {
        if(Array.isArray(e.model.value) && e.model.value.length > 1) {
          return {
            isMultiSelect: true,
            value: new Date(e.model.value[0]).toLocaleDateString(),
            value2: new Date(e.model.value[1]).toLocaleDateString(),
          }
        }
      }
      let value;
      if(typeof e.model.value === 'object') {
          if(Array.isArray(e.model.value)) {
            value = e.model.value.map((i) => i.id).join(',');
          }
          else if(e.model.value.id) {
            value = e.model.value.id.toString();
          }
          else if(e.model.value instanceof Date) {
            value = new Date(e.model.value.toLocaleDateString("en-US"));
          }
          else {
            value = e.model.value;
          }
      }
      else{
        value = e.model.value;
      }

      return { value }
    },
  },
}
</script>

<style scoped lang="scss">
.text-red {
  color: #c9545e;
}

::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}

.w-80 {
  width: 80%;
}

.w-20 {
  width: 20%;
}

.cursor-pointer {
  cursor: pointer;
}

.filter-row {
  background-color: #fce0c8;
  width: 50%;
  border-radius: 4px;
  padding: 1.5rem;
}

::v-deep .filter-row-saved {
  border-radius: 4px;
  padding: 1rem;
  border: 1px solid #e2e2e2;
}

.btn-circle {
  width: 35px;
  height: 35px;
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 20px;
}

.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}
.alert-icon {
  float: left;
}

.alert-content {
  margin-left: 1.2%;
  width: 100%;
  margin-right: 28px;
}

.alert span {
  text-align: left;
  font: Normal 16px/24px Lato;
  letter-spacing: 0;
  color: #af6708;
  opacity: 1;
}

.fa-bell-exclamation {
  font-size: 18px;
}
</style>
